import React from 'react';
import Box from '@mui/material/Box';
import { StyledLeadContainer } from '../../Components/Styled/index';
import { useSelector } from 'react-redux';
import { ACTIVE_STATUS, handleValidateCodevalue, VENDOR_STATUS } from '../../Utility/constant';
import { WhoColumns } from '../../Components/WhoColumns';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import CommonPoc from '../../Components/CommonPoc';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import './vendor.css';

const SearchVendor = ({ entityDetails,handleOnChange }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
const vendorStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == VENDOR_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    
    return (
        <Box className="vendor-search-fields">
            <StyledLeadContainer>
                    <TextFiledWithLabel
                    name="id"
                    type = "number"
                    label={handleValidateCodevalue(internationalise,'VEND_SEARCH_VENDOR_ID')}
                    value={entityDetails?.id}
                    handleOnChange={handleOnChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextFiledWithLabel id="name" 
                    label= {handleValidateCodevalue(internationalise,'VEND_SEARCH_NAME')} name="name"
                    handleOnChange={handleOnChange}
                    value={entityDetails?.name}
                />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name= "status"
                        value= {entityDetails?.status || ""}
                        isStatic={false}
                        optionMenuItem={vendorStatusData}
                        label={handleValidateCodevalue(internationalise,'VEND_SEARCH_STATUS')}
                        handleOnChange={handleOnChange}
                    />
                    
                <TextFiledWithLabel
                    className="vendor-search-hidden-field"
                />
            </StyledLeadContainer>
                <CommonPoc
                    handleOnChange={handleOnChange}
                    state={entityDetails}
                />
            <WhoColumns
            searchState ={entityDetails}
            handleOnChange = {handleOnChange} 
            />
        </Box>
    );
}

export default SearchVendor;
